// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main{ margin: 240px 80px 100px 80px; }
.dashboard-admin h1{ font-size: 18px; }

/* -- Anchos columnas -- */
.dashboard-admin .citas{ width: 280px!important; }
.dashboard-admin .expedientes{ width: 100% }

/* -- Layout del widget unificado -- */
.dashboard-admin .portada.between {
  align-items: flex-start;
  gap: 30px;
}

.dashboard-admin .widget-unificado-container {
  flex: 1 1;
  min-width: 0; /* Permite que el contenedor se reduzca si es necesario */
}

.dashboard-admin .widget-unificado-container .empleo-destacado {
  width: 100%;
}

.dashboard-admin .widget-unificado-container .titulo-user {
  margin-bottom: 20px;
}

/* -- Botones -- */
.dashboard-admin .boton{ 
  display: block;
  border: 1px solid #007932; 
  border-radius: 10px;
  padding: 10px 14px;
  text-align: center;
  font-weight: bold;
}

.dashboard-admin .boton:hover{ 
  background-color: #007932;
  color: white;
  text-decoration: none;
}


/* -----------------------------------------------------------------------------
// PRÓXIMAS CITAS
// ----------------------------------------------------------------------------- */
.dashboard-admin .proxima-cita{ 
  border: 1px solid #007932;
  border-left: 12px solid #007932; 
  border-radius: 12px;
  margin: 12px 0;
  padding: 12px 18px 16px 20px;
  gap: 3px;
}


/* -----------------------------------------------------------------------------
// CITAS PENDIENTES DE AGENDAR
// ----------------------------------------------------------------------------- */
.dashboard-admin .proxima-cita.rojo{ 
  border: 1px solid #8E151D;
  border-left: 12px solid #8E151D; 
}

.dashboard-admin .proxima-cita.rojo button:hover{
   text-decoration: underline; 
   background-color: white;
   color: #8E151D;
}

.dashboard-admin .proxima-cita.rojo .botones button:hover{
  background-color: #007932;
  color: #fff;
  text-decoration: none;
}


/* -----------------------------------------------------------------------------
// BOTÓN AÑADIR USUARIO
// ----------------------------------------------------------------------------- */
.dashboard-admin .expedientes .boton{ padding: 8px 14px 6px 14px; }


/* -----------------------------------------------------------------------------
// BOTÓN FILTROS
// ----------------------------------------------------------------------------- */

.expedientes .boton-filtros{
  gap: 10px;
  border: 2px solid white;
  background-color: transparent;
  font-size: 20px;
  padding: 0px 10px;
  border-radius: 0px;
  position: relative;
}

.expedientes .boton-filtros:hover{ color: #000; }


/* -----------------------------------------------------------------------------
// FILTROS
// ----------------------------------------------------------------------------- */
.expedientes .filtros {
  position: absolute;
  top: 245px;
  right: 0;
  width: 450px;
  height: calc(100vh - 335px);
  overflow-y: auto;  /* Agrega scroll solo si el contenido excede el height */
  background: #ffffff;
  padding: 0px 25px 5px 25px;
  box-shadow: -5px 4px 5px rgba(0, 0, 0, 0.1);
}

/* Header de filtros con título y botón cerrar */
.expedientes .header-filtros {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 15px 15px 15px;
  border-bottom: 2px solid #007932;
  margin-bottom: 5px;
  position: sticky;
  top: 0;
  background: white;
  z-index: 10;
}

.expedientes .header-filtros h3 {
  margin: 0;
  font-size: 20px;
  font-weight: bold;
  color: #007932;
}

.expedientes .boton-cerrar-filtros {
  background: none;
  border: none;
  font-size: 40px;
  color: #666;
  cursor: pointer;
  padding: 5px;
  border-radius: 50%;
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.expedientes .boton-cerrar-filtros:hover {
  background-color: #f0f0f0;
  color: #007932;
  transform: scale(1.1);
}

.expedientes .filtro{
  border-bottom: 1px solid black;
  padding: 20px 15px 18px 15px;
}

.expedientes .nombre-filtro {
  font-size: 20px;
  font-weight: bold;
}

.expedientes .filtro-contenido { margin-top: 10px; }


/* Estilo opciones de cada filtro */  
.expedientes .radio, .expedientes .checkbox {  gap: 10px 25px; }
.expedientes .filtro-contenido label{ cursor: pointer; }

.expedientes .radio label{ 
  display: flex;
  align-items: center;
  gap: 2.5px;
}

.expedientes .checkbox div { gap: 5px; }

.expedientes .checkbox .programa{width: 100%;}

.expedientes .filtro-contenido input[type="radio"] {
  appearance: none;
  margin-right: 5px;
  width: 14px;
  height: 14px;
  border: 3px solid rgb(207, 207, 207);
  border-radius: 50%;
  cursor: pointer;
  display: inline-block;
  position: relative;
  background-color: rgb(207, 207, 207);
  font-weight: 500;
}

.expedientes .filtro-contenido input[type="radio"]:hover { background-color: #007932d0; }
.expedientes .filtro-contenido input[type="radio"]:checked { background-color: #007932; }
.expedientes .fecha{ gap: 40px; }
.expedientes .fecha label:hover{ cursor: default; }
.expedientes .fecha input:hover{ cursor: pointer; }
.expedientes .fecha div{ gap: 7.5px; }

.expedientes .filtro-contenido input[type="date"] {
  padding: 0px;
  border: none;
  border-bottom: 1px solid #000000;
  color: #000000aa
}

.expedientes .filtro-contenido input[type="date"]:focus { outline: none; }

.expedientes .filtro-edad { gap: 5px; }
.expedientes .barra-edad  { height: 30px; }

.range {
  pointer-events: none; /* Para que no afecten el click en la zona, salvo en el thumb */
  left: 0;
  right: 0;
  top: 0;
  height: 30px;
  margin: 0;
  background: none;
  appearance: none; 
 /*  -webkit-appearance: none; /* Quita estilos por defecto en Safari/Chrome */
}

/* Estilos específicos para el track (barra) */
.range::-webkit-slider-runnable-track {
  height: 6px;
  background: #ddd; 
  border-radius: 3px;
}
.range::-moz-range-track {
  height: 6px;
  background: #ddd;
  border-radius: 3px;
}

/* Estilos para el pulgar (handle) */
.range::-webkit-slider-thumb {
  pointer-events: all; /* Permitir que se pueda arrastrar */
  width: 16px;
  height: 16px;
  margin-top: -5px; /* Centrar verticalmente */
  background: #007932;
  border-radius: 50%;
  -webkit-appearance: none;
}
.range::-moz-range-thumb {
  pointer-events: all;
  width: 16px;
  height: 16px;
  background: #007932;
  border-radius: 50%;
}

/* Para asegurarnos de que el input "min" quede por encima del "max" */
.range.range-min,
.range.range-max { 
  position: absolute;
  z-index: 5; }

/* La franja "rellena" entre min y max */
.barra-verde {
  top: 50%;
  height: 6px;
  transform: translateY(-50%);
  border-radius: 3px;
  z-index: 20;
}


/* -- Botón limpiar filtros -- */
.expedientes .limpiar{
  display: flex;
  margin-top: 25px;
  padding: 0px 20px 15px 0px;
  border: none;
  margin-left: auto;
}

.expedientes .limpiar:hover{
  text-decoration: underline;
  background-color: white;
  color: black;
}

/* -- Scroll vertical de filtros -- */
.expedientes .filtros::-webkit-scrollbar { width: 8px; }

.expedientes .filtros::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 5px;
}

/* -----------------------------------------------------------------------------
// LISTADO EXPEDIENTES
// ----------------------------------------------------------------------------- */
.expedientes .listado-expedientes{ 
  margin: 25px 0px 0px 0px; 
  gap: 20px 1.8%;
}

.scrollable {
  max-height: 100%; /* Ajusta según el alto aproximado de cada tarjeta */
  overflow-y: auto;
  padding-right: 8px; /* espacio para el scroll */
}



@media (min-width: 1600px) {
  .expedientes .listado-expedientes{ gap: 20px 2.5%; }
}

@media (max-width: 1220px) {
  .expedientes .listado-expedientes{ gap: 20px 4%; }
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/css/Dashboard.css"],"names":[],"mappings":"AAAA,OAAO,6BAA6B,EAAE;AACtC,qBAAqB,eAAe,EAAE;;AAEtC,0BAA0B;AAC1B,yBAAyB,sBAAsB,EAAE;AACjD,+BAA+B,YAAY;;AAE3C,sCAAsC;AACtC;EACE,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,YAAY,EAAE,yDAAyD;AACzE;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;;AAGA;;kFAEkF;AAClF;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,mBAAmB;EACnB,cAAc;EACd,4BAA4B;EAC5B,QAAQ;AACV;;;AAGA;;kFAEkF;AAClF;EACE,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;GACG,0BAA0B;GAC1B,uBAAuB;GACvB,cAAc;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,qBAAqB;AACvB;;;AAGA;;kFAEkF;AAClF,sCAAsC,0BAA0B,EAAE;;;AAGlE;;kFAEkF;;AAElF;EACE,SAAS;EACT,uBAAuB;EACvB,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,mCAAmC,WAAW,EAAE;;;AAGhD;;kFAEkF;AAClF;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,2BAA2B;EAC3B,gBAAgB,GAAG,wDAAwD;EAC3E,mBAAmB;EACnB,0BAA0B;EAC1B,2CAA2C;AAC7C;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,4BAA4B;EAC5B,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,MAAM;EACN,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA,iCAAiC,gBAAgB,EAAE;;;AAGnD,mCAAmC;AACnC,+CAA+C,cAAc,EAAE;AAC/D,sCAAsC,eAAe,EAAE;;AAEvD;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;AACZ;;AAEA,6BAA6B,QAAQ,EAAE;;AAEvC,iCAAiC,WAAW,CAAC;;AAE7C;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA,2DAA2D,2BAA2B,EAAE;AACxF,6DAA6D,yBAAyB,EAAE;AACxF,qBAAqB,SAAS,EAAE;AAChC,iCAAiC,eAAe,EAAE;AAClD,iCAAiC,eAAe,EAAE;AAClD,yBAAyB,UAAU,EAAE;;AAErC;EACE,YAAY;EACZ,YAAY;EACZ,gCAAgC;EAChC;AACF;;AAEA,0DAA0D,aAAa,EAAE;;AAEzE,4BAA4B,QAAQ,EAAE;AACtC,4BAA4B,YAAY,EAAE;;AAE1C;EACE,oBAAoB,EAAE,+DAA+D;EACrF,OAAO;EACP,QAAQ;EACR,MAAM;EACN,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,gBAAgB;CACjB,6EAA6E;AAC9E;;AAEA,8CAA8C;AAC9C;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,oCAAoC;AACpC;EACE,mBAAmB,EAAE,oCAAoC;EACzD,WAAW;EACX,YAAY;EACZ,gBAAgB,EAAE,0BAA0B;EAC5C,mBAAmB;EACnB,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,sEAAsE;AACtE;;EAEE,kBAAkB;EAClB,UAAU,EAAE;;AAEd,wCAAwC;AACxC;EACE,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,kBAAkB;EAClB,WAAW;AACb;;;AAGA,gCAAgC;AAChC;EACE,aAAa;EACb,gBAAgB;EAChB,0BAA0B;EAC1B,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,YAAY;AACd;;AAEA,qCAAqC;AACrC,2CAA2C,UAAU,EAAE;;AAEvD;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;kFAEkF;AAClF;EACE,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,gBAAgB,EAAE,oDAAoD;EACtE,gBAAgB;EAChB,kBAAkB,EAAE,2BAA2B;AACjD;;;;AAIA;EACE,mCAAmC,cAAc,EAAE;AACrD;;AAEA;EACE,mCAAmC,YAAY,EAAE;AACnD","sourcesContent":[".main{ margin: 240px 80px 100px 80px; }\n.dashboard-admin h1{ font-size: 18px; }\n\n/* -- Anchos columnas -- */\n.dashboard-admin .citas{ width: 280px!important; }\n.dashboard-admin .expedientes{ width: 100% }\n\n/* -- Layout del widget unificado -- */\n.dashboard-admin .portada.between {\n  align-items: flex-start;\n  gap: 30px;\n}\n\n.dashboard-admin .widget-unificado-container {\n  flex: 1;\n  min-width: 0; /* Permite que el contenedor se reduzca si es necesario */\n}\n\n.dashboard-admin .widget-unificado-container .empleo-destacado {\n  width: 100%;\n}\n\n.dashboard-admin .widget-unificado-container .titulo-user {\n  margin-bottom: 20px;\n}\n\n/* -- Botones -- */\n.dashboard-admin .boton{ \n  display: block;\n  border: 1px solid #007932; \n  border-radius: 10px;\n  padding: 10px 14px;\n  text-align: center;\n  font-weight: bold;\n}\n\n.dashboard-admin .boton:hover{ \n  background-color: #007932;\n  color: white;\n  text-decoration: none;\n}\n\n\n/* -----------------------------------------------------------------------------\n// PRÓXIMAS CITAS\n// ----------------------------------------------------------------------------- */\n.dashboard-admin .proxima-cita{ \n  border: 1px solid #007932;\n  border-left: 12px solid #007932; \n  border-radius: 12px;\n  margin: 12px 0;\n  padding: 12px 18px 16px 20px;\n  gap: 3px;\n}\n\n\n/* -----------------------------------------------------------------------------\n// CITAS PENDIENTES DE AGENDAR\n// ----------------------------------------------------------------------------- */\n.dashboard-admin .proxima-cita.rojo{ \n  border: 1px solid #8E151D;\n  border-left: 12px solid #8E151D; \n}\n\n.dashboard-admin .proxima-cita.rojo button:hover{\n   text-decoration: underline; \n   background-color: white;\n   color: #8E151D;\n}\n\n.dashboard-admin .proxima-cita.rojo .botones button:hover{\n  background-color: #007932;\n  color: #fff;\n  text-decoration: none;\n}\n\n\n/* -----------------------------------------------------------------------------\n// BOTÓN AÑADIR USUARIO\n// ----------------------------------------------------------------------------- */\n.dashboard-admin .expedientes .boton{ padding: 8px 14px 6px 14px; }\n\n\n/* -----------------------------------------------------------------------------\n// BOTÓN FILTROS\n// ----------------------------------------------------------------------------- */\n\n.expedientes .boton-filtros{\n  gap: 10px;\n  border: 2px solid white;\n  background-color: transparent;\n  font-size: 20px;\n  padding: 0px 10px;\n  border-radius: 0px;\n  position: relative;\n}\n\n.expedientes .boton-filtros:hover{ color: #000; }\n\n\n/* -----------------------------------------------------------------------------\n// FILTROS\n// ----------------------------------------------------------------------------- */\n.expedientes .filtros {\n  position: absolute;\n  top: 245px;\n  right: 0;\n  width: 450px;\n  height: calc(100vh - 335px);\n  overflow-y: auto;  /* Agrega scroll solo si el contenido excede el height */\n  background: #ffffff;\n  padding: 0px 25px 5px 25px;\n  box-shadow: -5px 4px 5px rgba(0, 0, 0, 0.1);\n}\n\n/* Header de filtros con título y botón cerrar */\n.expedientes .header-filtros {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 15px 15px 15px;\n  border-bottom: 2px solid #007932;\n  margin-bottom: 5px;\n  position: sticky;\n  top: 0;\n  background: white;\n  z-index: 10;\n}\n\n.expedientes .header-filtros h3 {\n  margin: 0;\n  font-size: 20px;\n  font-weight: bold;\n  color: #007932;\n}\n\n.expedientes .boton-cerrar-filtros {\n  background: none;\n  border: none;\n  font-size: 40px;\n  color: #666;\n  cursor: pointer;\n  padding: 5px;\n  border-radius: 50%;\n  width: 35px;\n  height: 35px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.expedientes .boton-cerrar-filtros:hover {\n  background-color: #f0f0f0;\n  color: #007932;\n  transform: scale(1.1);\n}\n\n.expedientes .filtro{\n  border-bottom: 1px solid black;\n  padding: 20px 15px 18px 15px;\n}\n\n.expedientes .nombre-filtro {\n  font-size: 20px;\n  font-weight: bold;\n}\n\n.expedientes .filtro-contenido { margin-top: 10px; }\n\n\n/* Estilo opciones de cada filtro */  \n.expedientes .radio, .expedientes .checkbox {  gap: 10px 25px; }\n.expedientes .filtro-contenido label{ cursor: pointer; }\n\n.expedientes .radio label{ \n  display: flex;\n  align-items: center;\n  gap: 2.5px;\n}\n\n.expedientes .checkbox div { gap: 5px; }\n\n.expedientes .checkbox .programa{width: 100%;}\n\n.expedientes .filtro-contenido input[type=\"radio\"] {\n  appearance: none;\n  margin-right: 5px;\n  width: 14px;\n  height: 14px;\n  border: 3px solid rgb(207, 207, 207);\n  border-radius: 50%;\n  cursor: pointer;\n  display: inline-block;\n  position: relative;\n  background-color: rgb(207, 207, 207);\n  font-weight: 500;\n}\n\n.expedientes .filtro-contenido input[type=\"radio\"]:hover { background-color: #007932d0; }\n.expedientes .filtro-contenido input[type=\"radio\"]:checked { background-color: #007932; }\n.expedientes .fecha{ gap: 40px; }\n.expedientes .fecha label:hover{ cursor: default; }\n.expedientes .fecha input:hover{ cursor: pointer; }\n.expedientes .fecha div{ gap: 7.5px; }\n\n.expedientes .filtro-contenido input[type=\"date\"] {\n  padding: 0px;\n  border: none;\n  border-bottom: 1px solid #000000;\n  color: #000000aa\n}\n\n.expedientes .filtro-contenido input[type=\"date\"]:focus { outline: none; }\n\n.expedientes .filtro-edad { gap: 5px; }\n.expedientes .barra-edad  { height: 30px; }\n\n.range {\n  pointer-events: none; /* Para que no afecten el click en la zona, salvo en el thumb */\n  left: 0;\n  right: 0;\n  top: 0;\n  height: 30px;\n  margin: 0;\n  background: none;\n  appearance: none; \n /*  -webkit-appearance: none; /* Quita estilos por defecto en Safari/Chrome */\n}\n\n/* Estilos específicos para el track (barra) */\n.range::-webkit-slider-runnable-track {\n  height: 6px;\n  background: #ddd; \n  border-radius: 3px;\n}\n.range::-moz-range-track {\n  height: 6px;\n  background: #ddd;\n  border-radius: 3px;\n}\n\n/* Estilos para el pulgar (handle) */\n.range::-webkit-slider-thumb {\n  pointer-events: all; /* Permitir que se pueda arrastrar */\n  width: 16px;\n  height: 16px;\n  margin-top: -5px; /* Centrar verticalmente */\n  background: #007932;\n  border-radius: 50%;\n  -webkit-appearance: none;\n}\n.range::-moz-range-thumb {\n  pointer-events: all;\n  width: 16px;\n  height: 16px;\n  background: #007932;\n  border-radius: 50%;\n}\n\n/* Para asegurarnos de que el input \"min\" quede por encima del \"max\" */\n.range.range-min,\n.range.range-max { \n  position: absolute;\n  z-index: 5; }\n\n/* La franja \"rellena\" entre min y max */\n.barra-verde {\n  top: 50%;\n  height: 6px;\n  transform: translateY(-50%);\n  border-radius: 3px;\n  z-index: 20;\n}\n\n\n/* -- Botón limpiar filtros -- */\n.expedientes .limpiar{\n  display: flex;\n  margin-top: 25px;\n  padding: 0px 20px 15px 0px;\n  border: none;\n  margin-left: auto;\n}\n\n.expedientes .limpiar:hover{\n  text-decoration: underline;\n  background-color: white;\n  color: black;\n}\n\n/* -- Scroll vertical de filtros -- */\n.expedientes .filtros::-webkit-scrollbar { width: 8px; }\n\n.expedientes .filtros::-webkit-scrollbar-thumb {\n  background: #ccc;\n  border-radius: 5px;\n}\n\n/* -----------------------------------------------------------------------------\n// LISTADO EXPEDIENTES\n// ----------------------------------------------------------------------------- */\n.expedientes .listado-expedientes{ \n  margin: 25px 0px 0px 0px; \n  gap: 20px 1.8%;\n}\n\n.scrollable {\n  max-height: 100%; /* Ajusta según el alto aproximado de cada tarjeta */\n  overflow-y: auto;\n  padding-right: 8px; /* espacio para el scroll */\n}\n\n\n\n@media (min-width: 1600px) {\n  .expedientes .listado-expedientes{ gap: 20px 2.5%; }\n}\n\n@media (max-width: 1220px) {\n  .expedientes .listado-expedientes{ gap: 20px 4%; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
